import React, { FC } from "react";
import {
  Button,
  Typography,
  Modal,
  Checkbox,
  Divider,
  FormGroup,
  FormControlLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowUpIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownIcon from "@mui/icons-material/ArrowDownward";
import { StyledModalDiv } from "../../../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useExportSelector from "./useExportSelector";

const StyledDivCol = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: 10,
});

const StyledDivCol2 = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  padding: 10,
});

const StyledDivColEnd = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  flexDirection: "column",
  padding: 10,
});

const StyledDivRow = styled("div")({
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
});

const StyledDivRowStart = styled(Typography)({
  alignSelf: "flex-start",
  paddingTop: 10,
});

const StyledDivRowCenter = styled("div")({
  display: "flex",
  justifyContent: "center",
  padding: 10,
});

const StyledDivToFrom = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  width: 50,
});

interface ExportFilterModalProps {
  handleClose: () => void;
  open: boolean;
  showTab: string;
  searchTerm: string;
  searchTermFilter: string;
  isSearch: boolean;
  showArchive?: string;
  showActive?: string;
}

const ExportFilterModal: FC<ExportFilterModalProps> = ({
  handleClose,
  open,
  showTab,
  searchTerm,
  searchTermFilter,
  isSearch,
  showArchive,
  showActive,
}) => {
  const {
    handleServiceExport,
    handleCustomerExport,
    getSalesReportExportData,
    getExportData,
    handleCheckCompleted,
    handleCheck,
    handleSortByChange,
    handleSortClick,
    handleChange,
    newdate,
    isDealer,
    error,
    sort,
    sortBy,
    loadingCsv,
    modalStyle,
    includeCompleted,
    checked,
    date,
  } = useExportSelector(
    showTab,
    searchTerm,
    searchTermFilter,
    isSearch,
    showArchive,
    showActive,
    open
  );

  const body = (
    <StyledModalDiv style={modalStyle}>
      <StyledDivCol>
        <div style={{ borderBottom: "solid black 2px" }}>
          <h2 style={{ fontWeight: "bold" }}>Export Table to Excel</h2>
        </div>

        <StyledDivRowStart>Sort</StyledDivRowStart>

        <StyledDivCol>
          <StyledDivRow style={{ padding: 5 }}>
            <Button
              size="small"
              variant={sort === "Ascending" ? "contained" : "outlined"}
              color="primary"
              onClick={() => handleSortClick("Ascending")}
            >
              <ArrowUpIcon style={{ fontSize: 14 }} />
              Ascending
            </Button>
            <Button
              size="small"
              variant={sort === "Descending" ? "contained" : "outlined"}
              color="primary"
              onClick={() => handleSortClick("Descending")}
            >
              <ArrowDownIcon style={{ fontSize: 14 }} />
              Descending
            </Button>
          </StyledDivRow>

          <StyledDivRow style={{ padding: 10 }}>
            <Typography style={{ fontWeight: "bold" }}>Sort By:</Typography>
            {showTab === "Sales Reports" ? (
              <Select
                onChange={handleSortByChange}
                value={sortBy}
                variant="outlined"
                margin="dense"
                size="small"
                style={{ width: 180 }}
              >
                <MenuItem value="date">Date</MenuItem>
                <MenuItem value="dealer">Dealer</MenuItem>
              </Select>
            ) : showTab === "Customer List" ? (
              <Select
                onChange={handleSortByChange}
                value={sortBy}
                variant="outlined"
                margin="dense"
                size="small"
                style={{ width: 180 }}
              >
                <MenuItem value="dealer">Dealer</MenuItem>
                <MenuItem value="factor">Factor</MenuItem>
                <MenuItem value="role">Role</MenuItem>
                <MenuItem value="date">Date</MenuItem>
              </Select>
            ) : showTab === "Service Repair" ? (
              <Select
                onChange={handleSortByChange}
                value={sortBy}
                variant="outlined"
                margin="dense"
                size="small"
                style={{ width: 180 }}
              >
                <MenuItem value="dealer">Dealer</MenuItem>
                <MenuItem value="date">Date Created</MenuItem>
              </Select>
            ) : (
              <Select
                onChange={handleSortByChange}
                value={sortBy}
                variant="outlined"
                margin="dense"
                size="small"
                style={{ width: 180 }}
              >
                <MenuItem value="date">Date</MenuItem>
                <MenuItem value="quoteNumber">Quote Number</MenuItem>
                <MenuItem value="grandTotal">Dealer Cost</MenuItem>
                {!isDealer && <MenuItem value="dealer">Dealer</MenuItem>}
              </Select>
            )}
          </StyledDivRow>

          {showTab === "Service Repair" && (
            <StyledDivRowCenter>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      onChange={handleCheckCompleted}
                      checked={includeCompleted}
                    />
                  }
                  label="Include Completed Service?"
                />
              </FormGroup>
            </StyledDivRowCenter>
          )}
        </StyledDivCol>
      </StyledDivCol>

      <Divider style={{ width: "100%" }} />

      {showTab !== "Customer List" && (
        <StyledDivCol2>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  onChange={handleCheck}
                  checked={checked}
                />
              }
              label="Filter By Date"
            />
          </FormGroup>
          {checked && (
            <>
              <StyledDivColEnd>
                <StyledDivRow style={{ padding: 10, width: "100%" }}>
                  <StyledDivToFrom>
                    <Typography style={{ fontWeight: "bold" }}>
                      From:
                    </Typography>
                  </StyledDivToFrom>
                  <input
                    type="date"
                    name="startDate"
                    value={date.startDate}
                    onChange={handleChange}
                    max={newdate}
                    style={{ marginLeft: 10 }}
                  />
                </StyledDivRow>
                <StyledDivRow style={{ padding: 10, width: "100%" }}>
                  <StyledDivToFrom>
                    <Typography style={{ fontWeight: "bold" }}>To:</Typography>
                  </StyledDivToFrom>
                  <input
                    type="date"
                    name="endDate"
                    value={date.endDate}
                    onChange={handleChange}
                    min={date.startDate || ""}
                    max={newdate}
                    style={{ marginLeft: 10 }}
                  />
                </StyledDivRow>
              </StyledDivColEnd>
            </>
          )}
        </StyledDivCol2>
      )}

      {error && (
        <StyledDivRowCenter>
          <Typography style={{ color: "red", fontWeight: "bold" }}>
            No Results Found
          </Typography>
        </StyledDivRowCenter>
      )}

      <StyledDivRowCenter>
        <Button
          style={{ marginRight: 20 }}
          onClick={handleClose}
          variant="contained"
          color="inherit"
        >
          Cancel
        </Button>

        {!loadingCsv ? (
          <Button
            variant="contained"
            style={{
              backgroundColor: "#478d4b",
              color: "white",
              marginLeft: 20,
            }}
            onClick={
              showTab === "Sales Reports"
                ? getSalesReportExportData
                : showTab === "Customer List"
                ? handleCustomerExport
                : showTab === "Service Repair"
                ? handleServiceExport
                : getExportData
            }
            disabled={loadingCsv}
          >
            Export
          </Button>
        ) : (
          <Typography>Generating...</Typography>
        )}
      </StyledDivRowCenter>
    </StyledModalDiv>
  );

  return (
    <Modal open={open} onClose={handleClose}>
      {body}
    </Modal>
  );
};

export default ExportFilterModal;
